import Link from 'next/link';

interface WhyDiveInCyprusProps {
  className?: string;
}

const stats = [
  { value: '300+', label: 'days of sunshine' },
  { value: '20–40m', label: 'typical visibility' },
  { value: '17–28°C', label: 'water temperatures' },
  { value: '40+', label: 'dive sites across the island' },
  { value: 'Turtles, groupers & octopus', label: 'marine life highlights' },
  { value: 'All levels', label: 'beginners to experienced divers' },
];

const WhyDiveInCyprus = ({ className = '' }: WhyDiveInCyprusProps) => {
  return (
    <section
      className={`py-12 sm:py-16 md:py-20 ${className}`}
      style={{
        background: '#0E1C2B',
        borderTop: '1px solid rgba(255,255,255,0.06)'
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-8 sm:mb-10 md:mb-12">
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-headline font-bold mb-4"
              style={{ color: '#EAF4F8' }}
            >
              Why Dive Cyprus?
            </h2>
            <div className="w-12 h-0.5 mx-auto mb-6" style={{ background: '#6FD3E0' }} />
            <p
              className="text-base sm:text-lg max-w-2xl mx-auto mb-4 leading-relaxed"
              style={{ color: '#A9C3CF' }}
            >
              Cyprus offers some of the most reliable and accessible diving in the Mediterranean.
            </p>
            <p
              className="text-sm sm:text-base max-w-2xl mx-auto mb-6 leading-relaxed"
              style={{ color: '#A9C3CF' }}
            >
              Warm, clear water, long seasons, and a mix of wrecks, reefs, caves, and shore dives make it suitable for all levels — from beginners to experienced divers.
            </p>
            {/* Zenobia highlight */}
            <div
              className="inline-block rounded-xl px-5 py-4 text-left max-w-2xl mx-auto"
              style={{
                background: '#0F2234',
                border: '1px solid rgba(111,211,224,0.22)',
              }}
            >
              <p className="text-sm sm:text-base leading-relaxed" style={{ color: '#C8DDE6' }}>
                <strong style={{ color: '#EAF4F8' }}>The Zenobia wreck</strong> — a 178m ferry in Larnaca Bay — is consistently ranked among the{' '}
                <Link
                  href="/dive-sites/zenobia"
                  className="font-semibold underline underline-offset-2 transition-opacity hover:opacity-80"
                  style={{ color: '#6FD3E0' }}
                >
                  world&apos;s top wreck dives
                </Link>
                .
              </p>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-5">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center text-center px-4 py-5 rounded-2xl"
                style={{
                  background: '#0F2234',
                  border: '1px solid rgba(255,255,255,0.08)'
                }}
              >
                <span
                  className="text-lg sm:text-xl font-bold mb-1"
                  style={{ color: '#6FD3E0' }}
                >
                  {stat.value}
                </span>
                <span
                  className="text-xs sm:text-sm leading-snug"
                  style={{ color: '#A9C3CF' }}
                >
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDiveInCyprus;
